/**
 * Created by Ning Jiang on 2021-05-28.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {DeadwoodRip} from "../../DeadwoodRip";
import {TimelineLite} from "gsap";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {IS1} from "../../symbol/IS1";
import {DeadwoodRipS1Symbol} from "../../symbol/DeadwoodRipS1Symbol";
import {DeadwoodRipSound} from "../../sound/DeadwoodRipSound";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class S1LandingController extends ReelStopPresentationController {

    private readonly _numOfScattersToWin:number = 3;

    private _scatters:IS1[];
    private _animations:TimelineLite[] = [];
    private _isNearWinPlaying:boolean;

    constructor() {
        super("S1LandingController");
    }

    protected onReelBounce(data:IReelStateEventData):Promise<any> {
        if(data.reelId === 3 && !DeadwoodRip.reels[3].isQuickStop && !DeadwoodRip.model.parsedGameData.nearWinReels[4] && DeadwoodRip.model.parsedGameData.nearWinBigWinReels[4]) {
            this._isNearWinPlaying = true;
            DeadwoodRip.nearWinView.playBigWinNearWin();
            DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.SCATTER_ANTICIPATION_2});
        }

        const scatterPosition = DeadwoodRip.model.parsedGameData.S1Positions![data.reelId];
        if(scatterPosition === -1) {
            if(data.reelId === 3 && this._scatters.length < 3) {
                // no win, stop all attention and near win.
                if(this._isNearWinPlaying) {
                    if(!DeadwoodRip.model.parsedGameData.nearWinBigWinReels[4]) {
                        this._isNearWinPlaying = false;
                        DeadwoodRip.nearWinView.stopNearWin();
                        DeadwoodRipSound.soundPlayer.playTrack({
                            name : DeadwoodRip.model.parsedGameData.mode === GameMode.NORMAL ?
                                DeadwoodRipSound.SCATTER_ANTICIPATION_FAIL :
                                DeadwoodRipSound.SCATTER_FS_ANTICIPATION_FAIL
                        });
                    }
                    DeadwoodRipSound.soundPlayer.stopTrack(DeadwoodRipSound.SCATTER_ANTICIPATION);
                    this._scatters.forEach(s => {
                        s.playNormalLanding(0).progress(1);
                    });
                }
                this._animations.forEach(a => a.progress(1));
            }
            if(data.reelId === 4 && this._isNearWinPlaying) {
                // hard stop everything.
                this._isNearWinPlaying = false;
                DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.SCATTER_ANTICIPATION_2_LAND});
                DeadwoodRipSound.soundPlayer.stopTrack(DeadwoodRipSound.SCATTER_ANTICIPATION);
                const player = DeadwoodRipSound.soundPlayer.fetchSoundPlayer(DeadwoodRipSound.SCATTER_ANTICIPATION_2);
                if(player && player.isPlaying) {
                    DeadwoodRipSound.fadeAndStopSound({
                        name : DeadwoodRipSound.SCATTER_ANTICIPATION_2,
                        to : 0,
                        duration : 500
                    });
                }
                DeadwoodRip.nearWinView.stopNearWin();
            }
            return Promise.resolve();
        }

        const symbol = DeadwoodRip.reels[data.reelId].getSymbol(scatterPosition);
        this._scatters.push(<any>symbol);

        // When there is not enough reel left to win.
        if(this._scatters.length === 1 && data.reelId === 3) {
            return Promise.resolve();
        }

        return Promise.resolve(this.playAttentionAnimation(<DeadwoodRipS1Symbol>symbol, data.reelId));
    }

    private playAttentionAnimation(symbol:DeadwoodRipS1Symbol, reelId:number):Promise<any> {
        let ani:TimelineLite;
        if(this._scatters.length >= this._numOfScattersToWin) {
            // win fs
            DeadwoodRipSound.soundPlayer.playTrack({
                name : DeadwoodRip.model.parsedGameData.mode === GameMode.NORMAL ?
                    DeadwoodRipSound.SCATTER_ANTICIPATION_SUCCESS :
                    DeadwoodRipSound.SCATTER_FS_ANTICIPATION_SUCCESS
            });
            if(this._isNearWinPlaying) {
                DeadwoodRipSound.soundPlayer.stopTrack(DeadwoodRipSound.SCATTER_ANTICIPATION);

                if(DeadwoodRip.model.parsedGameData.mode.includes("FREESPIN")) {
                    this._isNearWinPlaying = false;
                    DeadwoodRip.nearWinView.stopNearWin();
                }
            }
            this._animations.forEach(a => a.progress(1));
            this._scatters.forEach(s => {
                this._animations.push(s.playWin(true));
            });
            ani = this._animations[this._animations.length - 1];
            if(!DeadwoodRip.reels[reelId].isQuickStop && DeadwoodRip.model.parsedGameData.mode === GameMode.NORMAL &&
                (!DeadwoodRip.model.parsedGameData.wasFeatureBuy || (DeadwoodRip.model.parsedGameData.wasFeatureBuy && SlotGame.apiPlugin.betFeatureController.getActiveBetFeature()?.name.includes("LUCKY_DRAW")))) {
                this._isNearWinPlaying = true;
                DeadwoodRip.nearWinView.playScatterNearWin(4);
                DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.SCATTER_ANTICIPATION_2});
            }
        } else if(this._scatters.length === 2 && reelId === 3 && (<any>symbol)["playWinWRSLanding"]) {
            // win transfer to WRS
            this._animations.forEach(a => a.progress(1));
            this._scatters.forEach((s, i) => {
                this._animations.push(s.playWinWRSLanding!(i === 0));
            });
            ani = this._animations[this._animations.length - 1];
        } else if(this._scatters.length === 2 && reelId === 2) {
            if(!DeadwoodRip.reels[reelId].isQuickStop && (!DeadwoodRip.model.parsedGameData.wasFeatureBuy || DeadwoodRip.model.parsedGameData.mode.includes("FREESPIN"))) {
                // start near win
                this._isNearWinPlaying = true;
                DeadwoodRip.nearWinView.playScatterNearWin(3);
                DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.SCATTER_ANTICIPATION});
            }
            ani = new TimelineLite();
            ani.add(this._scatters[this._scatters.length - 1].playNormalLanding(2));
            ani.add(() => {
                if(this._isNearWinPlaying) {
                    this._scatters.forEach(s => {
                        s.playNearWinLoop!();
                    });
                }
            });
            this._animations.push(ani);
        } else {
            // normal landing
            ani = this._scatters[this._scatters.length - 1].playNormalLanding(1);
            this._animations.push(ani);
        }

        return Promise.resolve(ani).then(res => {
            ArrayHelper.removeFirstMatchElement(this._animations, ani);
        });
    }

    protected reset() {
        super.reset();
        this._scatters = [];
    }
}